// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadShipperCard_card__2qlDN"};